import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const Bills = lazy(() => import('./Bills'));
const BillNew = lazy(() => import('./bill/BillNew'));
const BillEdit = lazy(() => import('./bill/BillEdit'));
const BillView = lazy(() => import('./bill/BillView'));
const BillsInsights = lazy(() => import('./insights/Insights'));
const BillingConfigurations = lazy(
  () => import('./configurations/BillingConfigurations'),
);

export const billRoutes: RouteObject[] = [
  {
    path: 'bills',
    children: [
      { index: true, element: <Bills /> },
      { path: 'new', element: <BillNew /> },
      { path: ':billId', element: <BillView /> },
      { path: ':billId/edit', element: <BillEdit /> },
      { path: 'insights', element: <BillsInsights /> },
      { path: 'billing-configurations', element: <BillingConfigurations /> },
    ],
  },
];
